import { render, staticRenderFns } from "./membersRecordDialog.vue?vue&type=template&id=50c6a9aa&"
import script from "./membersRecordDialog.vue?vue&type=script&lang=js&"
export * from "./membersRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./membersRecordDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports